export default __webpack_public_path__ + "static/media/V120_V124MANC5.f8017aa3.pdf";